import type { ConnectionState } from "../../types/chat";
import RefreshLinear from "~icons/solar/refresh-linear";

interface ConnectionBannerProps {
  state: ConnectionState;
}

/** Warning strip at the top of the chat when the socket is not connected. */
export function ConnectionBanner({ state }: ConnectionBannerProps) {
  if (state === "connected" || state === "connecting") return null;

  return (
    <div
      role="alert"
      className="sticky top-0 z-10 mb-2 flex items-center justify-center gap-2 rounded-full border border-warning/20 bg-warning-light px-4 py-2 text-xs font-semibold text-warning"
    >
      {state === "reconnecting" ? (
        <>
          <RefreshLinear aria-hidden="true" className="size-4 shrink-0 motion-safe:animate-spin" />
          <span>Connection lost. Reconnecting…</span>
        </>
      ) : (
        <>
          <span>Unable to connect.</span>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="underline underline-offset-2 hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warning/40"
          >
            Reload page
          </button>
        </>
      )}
    </div>
  );
}
